import intelLogo from "/img/navbar/carousel/intel.svg";
import qualcommLogo from "/img/navbar/carousel/qualcomm.png";
import siliconLogo from "/img/navbar/carousel/Silicon.png";
import scytLogo from "/img/navbar/carousel/logotipo_SCyT.svg";

export type PartnerLogo = {
  src: string;
  alt: string;
};

export const partnerLogos: PartnerLogo[] = [
  { src: intelLogo, alt: "Intel logo" },
  { src: qualcommLogo, alt: "Qualcomm logo" },
  { src: siliconLogo, alt: "Silicon logo" },
  { src: scytLogo, alt: "SCyT logo" },
];